import React from "react";

const LEVELS = {
  high: { label: "High Confidence", dot: "bg-emerald-400", text: "text-emerald-400", ring: "bg-emerald-500/15" },
  needs_verification: { label: "Needs Verification", dot: "bg-yellow-400", text: "text-yellow-400", ring: "bg-yellow-500/15" },
  low: { label: "Low Confidence", dot: "bg-orange-400", text: "text-orange-400", ring: "bg-orange-500/15" },
  unable: { label: "Unable To Verify", dot: "bg-red-400", text: "text-red-400", ring: "bg-red-500/15" },
};

export function confidenceLevelFrom(analysis) {
  if (!analysis) return "unable";
  if (analysis.confidence_level) return analysis.confidence_level;
  const c = analysis.confidence || 0;
  if (analysis.readable === false) return "unable";
  if (analysis.needs_verification) return "needs_verification";
  if (c >= 75) return "high";
  if (c >= 45) return "low";
  return "unable";
}

export default function ConfidenceBadge({ analysis, showReason = false, size = "sm" }) {
  const level = confidenceLevelFrom(analysis);
  const cfg = LEVELS[level] || LEVELS.unable;
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <span className="inline-flex flex-col gap-1" data-testid="confidence-badge">
      <span className={`inline-flex items-center gap-1.5 rounded-full font-bold ${pad} ${cfg.ring} ${cfg.text}`}>
        <span className={`h-2 w-2 rounded-full ${cfg.dot}`} />
        {cfg.label}
      </span>
      {showReason && analysis?.confidence_reason && (
        <span className="text-xs text-white/45 leading-snug">{analysis.confidence_reason}</span>
      )}
    </span>
  );
}
